import React from "react";
import { useTranslations } from "next-intl";

import { DescriptionText, PageTitle, StickyButton, Layout } from "@src/packages/chime-ui";
import { EditSettings } from "@src/components";

interface Props {
  onComplete: () => void;
}

export const EnableCameraAccessIphone = ({ onComplete }: Props) => {
  const t = useTranslations("permissions.iphone");

  return (
    <Layout>
      <EditSettings />
      <PageTitle role="heading">{t("title")}</PageTitle>
      <DescriptionText>{t("description")}</DescriptionText>

      <StickyButton name="tryAgain" onClick={onComplete}>
        {t("cta")}
      </StickyButton>
    </Layout>
  );
};
